import { IPropertyConverter } from "ta-json";

import { Nullable } from "../base-types";
import { InvalidOperationError } from "../errors/invalid-operation-error";
import { FileVersion } from "../fileversion";

export class FileVersionConverter implements IPropertyConverter {
    private isFileVersion(arg: object): arg is FileVersion {
        return (arg as FileVersion | Record<string, unknown>).major !== undefined;
    }

    /**
     * Serializes a FileVersion into a string.
     *
     * @param version - A FileVersion
     *
     * @returns A string.
     */
    serialize(version: FileVersion): Nullable<string> {
        if (!version) {
            throw new InvalidOperationError("Can't serialize falsy value.");
        } else if (!this.isFileVersion(version)) {
            throw new InvalidOperationError(
                `Expected a value of type 'FileVersion', but value was of type '${typeof version}'.`
            );
        }

        return version.toString();
    }

    /**
     * Deserializes a string into a FileVersion instance.
     *
     * @param value - A string
     *
     * @returns A FileVersion instance or null.
     */
    deserialize(value: string): FileVersion {
        if (!value) {
            throw new InvalidOperationError("Can't deserialize falsy value.");
        } else if (typeof value !== "string") {
            throw new InvalidOperationError(
                `Expected a value of type 'string', but value was of type '${typeof value}'.`
            );
        }

        return FileVersion.parse(value);
    }
}
